var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatUrgent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-341 381 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e54918"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-325 387c-5.5 0-10 3.6-10 8 0 2.9 1.9 5.5 5 6.9v5.1l5.3-4c5.4-.1 9.7-3.7 9.7-8 0-4.4-4.5-8-10-8zm0 14h-.3l-2.7 2v-2.4l-.6-.2c-2.7-1-4.4-3.1-4.4-5.3 0-3.3 3.6-6 8-6s8 2.7 8 6-3.6 5.9-8 5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-330 392h10v2h-10v-2zm0 4h7v2h-7v-2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatUrgent);
export default __webpack_public_path__ + "static/media/chat_urgent.d688bae7.svg";
export { ForwardRef as ReactComponent };